/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */
module.exports = function (file) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/index';
  return function () {
    return import("@/page".concat(file).concat(name));
  };
}; // export default (file,name='/index') => import(`@/page${file}${name}`)